import { getAttachmentColDefs } from 'app/pages/JobDetail/constant';
import React from 'react';
import { StyledTable, StyledTotalLabel } from '../../../Table';

type Props = {
  isLoading: boolean;
  dataSource: any[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
  onDelete: (documentId: number) => Promise<void>;
  onChange: (pagination: { page: number; pageSize: number }) => Promise<void>;
};
const TableView: React.FC<Props> = ({
  isLoading,
  dataSource,
  onDelete,
  pagination,
  onChange
}) => {
  const cols = getAttachmentColDefs(onDelete);
  return (
    <StyledTable
      tableLayout="auto"
      onChange={(nextPagination) => {
        onChange({
          page: nextPagination.current || 1,
          pageSize: nextPagination.pageSize || 10
        });
      }}
      loading={isLoading}
      rowKey={(record: any) => record.id}
      pagination={{
        ...pagination,
        pageSize: pagination.pageSize || 10,
        current: pagination.page,
        showSizeChanger: true,
        showTotal: (total, range) => {
          return (
            <StyledTotalLabel>
              {range[0]}-{range[1]} of {total}
            </StyledTotalLabel>
          );
        }
      }}
      dataSource={dataSource}
      columns={cols}
    ></StyledTable>
  );
};

export default TableView;
